import { render, staticRenderFns } from "./CompareResultList.vue?vue&type=template&id=465a6910"
import script from "./CompareResultList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareResultList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports